import React from 'react';

import { Drawer } from 'antd';

import type { CourseId } from '/imports/domain';
import { Loading } from '/imports/ui/components/Loading';
import type { ToggleDrawerProps } from '/imports/ui/components/ToggleDrawer';

const SendMessageForm = React.lazy(() => import('./SendMessageForm'));

export interface SendMessageProps {
  hideCourse?: boolean;
  defaultRequest?: 'codeExpert' | 'course';
  messageText?: string;
  additionalText?: string;
  defaultCourse?: CourseId;
  style?: React.CSSProperties;
}

export const SendMessage = ({
  hideCourse,
  defaultRequest,
  messageText,
  additionalText,
  defaultCourse,
  style,
  open,
  setOpen,
}: SendMessageProps & ToggleDrawerProps) => (
  <Drawer
    destroyOnHidden
    title="Send message"
    rootStyle={style}
    width={400}
    maskClosable={false}
    open={open}
    onClose={() => setOpen(false)}
  >
    <React.Suspense fallback={<Loading />}>
      <SendMessageForm
        close={() => setOpen(false)}
        hideCourse={hideCourse}
        defaultCourse={defaultCourse}
        defaultRequest={defaultRequest}
        messageText={messageText}
        additionalText={additionalText}
      />
    </React.Suspense>
  </Drawer>
);
